import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchAdminRoisAPI,
	linkRoiAPI,
	adminRevokeRoiAPI,
	approveRoiAPI,
	rejectRoiAPI,
} from 'utils/api';

import {
	fetchAdminRoisSuccess,
	fetchAdminRoisError,
	adminLinkRoiSuccess,
	adminLinkRoiError,
	adminRevokeRoiSuccess,
	adminRevokeRoiError,
	approveRoiMatchSuccess,
	approveRoiMatchError,
	rejectRoiMatchesSuccess,
	rejectRoiMatchesError,
	fetchAdminRois as fetchAdminRoisAction,
} from './actions';
import {
	FETCH_ADMIN_ROIS,
	ADMIN_LINK_ROI,
	ADMIN_REVOKE_ROI,
	APPROVE_ROI_MATCH,
	REJECT_ROI_MATCHES,
} from './constants';

export function* fetchAdminRois(action) {
	try {
		const response = yield call(fetchAdminRoisAPI, action.params);
		yield put(fetchAdminRoisSuccess(response));
	} catch (err) {
		yield put(fetchAdminRoisError(err));
	}
}

export function* adminLinkRoi(action) {
	try {
		const response = yield call(linkRoiAPI, action.data);
		yield put(adminLinkRoiSuccess(response));
		yield put(fetchAdminRoisAction());
	} catch (err) {
		yield put(adminLinkRoiError(err));
	}
}

export function* adminRevokeRoi(action) {
	try {
		const response = yield call(adminRevokeRoiAPI, action.data);
		yield put(adminRevokeRoiSuccess(response));
		yield put(fetchAdminRoisAction());
	} catch (err) {
		yield put(adminRevokeRoiError(err));
	}
}

export function* approveRoiMatch(action) {
	try {
		const response = yield call(approveRoiAPI, {
			roiId: action.roiId,
			candidateId: action.candidateId,
		});
		yield put(approveRoiMatchSuccess(response));
		yield put(fetchAdminRoisAction());
	} catch (err) {
		yield put(approveRoiMatchError(err));
	}
}

export function* rejectRoiMatches(action) {
	try {
		const response = yield call(rejectRoiAPI, { roiId: action.roiId });
		yield put(rejectRoiMatchesSuccess(response));
		yield put(fetchAdminRoisAction());
	} catch (err) {
		yield put(rejectRoiMatchesError(err));
	}
}

export default function* adminRoiListSaga() {
	yield takeLatest(FETCH_ADMIN_ROIS, fetchAdminRois);
	yield takeLatest(ADMIN_LINK_ROI, adminLinkRoi);
	yield takeLatest(ADMIN_REVOKE_ROI, adminRevokeRoi);
	yield takeLatest(APPROVE_ROI_MATCH, approveRoiMatch);
	yield takeLatest(REJECT_ROI_MATCHES, rejectRoiMatches);
}
